import {
    UNSYNCED_SALES_SYNC_STATUS,
    type UnsyncedSalesSyncStatus,
} from './types';

interface Props {
    status: UnsyncedSalesSyncStatus;
    count: number;
    onSync?: VoidFunction;
}

const contentMap: Record<UnsyncedSalesSyncStatus, (count: number) => string> = {
    [UNSYNCED_SALES_SYNC_STATUS.Idle]: (count) =>
        `You have ${count} sales waiting to sync. Please resolve your internet connection to avoid sync issues.`,
    [UNSYNCED_SALES_SYNC_STATUS.Error]: (count) =>
        `You have ${count} sales waiting to sync. Please resolve your internet connection to avoid sync issues.`,
    [UNSYNCED_SALES_SYNC_STATUS.Syncing]: (count) => `Syncing ${count} sales.`,
    [UNSYNCED_SALES_SYNC_STATUS.Success]: () => 'All sales have been synced.',
};

export function UnsyncedSalesSyncIndicator({
    status,
    count,
    onSync,
}: Readonly<Props>) {
    const content = contentMap[status](count);

    const showSyncButton =
        status === UNSYNCED_SALES_SYNC_STATUS.Idle ||
        status === UNSYNCED_SALES_SYNC_STATUS.Error;

    return (
        <div className='flex items-center justify-between'>
            <div className='flex gap-16 px-8'>{content}</div>

            {showSyncButton && (
                <button
                    className='text-14 font-semibold text-white'
                    onClick={onSync}>
                    Sync now
                </button>
            )}

            {status === UNSYNCED_SALES_SYNC_STATUS.Syncing && (
                <div className='h-4 w-120 overflow-hidden rounded-8 bg-feedback-default-ghost-pressed'>
                    <div
                        className='h-full animate-banner-progress bg-action-default-filled-default'
                        aria-label='Loading...'
                    />
                </div>
            )}
        </div>
    );
}
